import React from 'react';
import {
    Dialog,
    DialogHeader,
    DialogBody,
    DialogFooter,
    Button,
    Typography
} from '@material-tailwind/react';

const ConfirmDialog = ({
    open,
    title,
    message,
    confirmText = 'Confirm',
    cancelText = 'Cancel',
    confirmColor = 'red',
    onConfirm,
    onCancel,
    disabled = false,
    warningMessage = null
}) => {
    return (
        <Dialog open={open} handler={onCancel}>
            <DialogHeader>{title}</DialogHeader>
            <DialogBody>
                <Typography className="mb-2">
                    {message}
                </Typography>
                {warningMessage && (
                    <Typography color="red" className="text-sm">
                        {warningMessage}
                    </Typography>
                )}
            </DialogBody>
            <DialogFooter>
                <Button variant="outlined" onClick={onCancel} className="mr-2">
                    {cancelText}
                </Button>
                <Button
                    color={confirmColor}
                    onClick={onConfirm}
                    disabled={disabled}
                >
                    {confirmText}
                </Button>
            </DialogFooter>
        </Dialog>
    );
};

export default ConfirmDialog;
